import { PayloadAction, createPersistReducer, initReducer, PersistConfig } from "@grassrootly/rn-core";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { IGroup } from '@grassrootly/api';

export interface GroupsState {
  playerGroups: IGroup[];
}

const initialState: GroupsState = {
  playerGroups: [],
};

const groupsSlice = initReducer({
  name: "groups",
  initialState,
  reducers: {
    setPlayerGroups: (state: GroupsState, action: PayloadAction<IGroup[]>) => {
      state.playerGroups = action.payload;
    },
    cleanState: () => {
      return initialState;
    }
  },
});

const persistConfig: PersistConfig<GroupsState> = {
  key: "groups",
  storage: AsyncStorage,
};

export const groupsActions = groupsSlice.actions;

export default createPersistReducer(persistConfig, groupsSlice.reducer);
